import { render } from "./MyAccountRoomsViewPage.vue?vue&type=template&id=216ab8c0&scoped=true"
import script from "./MyAccountRoomsViewPage.vue?vue&type=script&lang=js"
export * from "./MyAccountRoomsViewPage.vue?vue&type=script&lang=js"

import "./MyAccountRoomsViewPage.vue?vue&type=style&index=0&id=216ab8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216ab8c0"]])

export default __exports__